import registerWebComp from '@helsenorge/framework-utils/web-component/register';

import CMSAgent from './cmsagent/index.tsx';
async function enableMocking(): Promise<ServiceWorkerRegistration | void> {
  if (import.meta.env.MODE !== 'mocks') {
    return;
  }

  const { worker } = await import('./mocks/browser.ts');

  return worker.start({
    onUnhandledRequest: 'bypass',
  });
}

enableMocking().then(() => {
  registerWebComp(CMSAgent, { name: 'hn-webcomp-cmsagent', templateId: 'hn-webcomp-cmsagent-template' });
});
